module.exports = __webpack_public_path__ + "static/histogram-with-specified-bins-cfd11e1453ff616cb40fa6f910699299.png";